export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-4xl mx-auto">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
              随时随地，追剧不停
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              97影院全面适配手机、平板与电脑端，无需下载APP，打开浏览器即可享受高清蓝光画质。收藏与观看记录云端同步，多设备无缝切换，通勤路上、午休间隙、睡前时光 — 随时随地继续你的追剧之旅。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <button className="px-6 py-3 bg-foreground-900 text-background-50 font-medium rounded-lg text-sm whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-colors">
                <i className="ri-android-line mr-2"></i>Android 版
              </button>
              <button className="px-6 py-3 bg-foreground-900 text-background-50 font-medium rounded-lg text-sm whitespace-nowrap cursor-pointer hover:bg-foreground-800 transition-colors">
                <i className="ri-apple-line mr-2"></i>iOS 版
              </button>
              <button className="px-6 py-3 bg-background-50 text-foreground-700 font-medium rounded-lg text-sm border border-background-300 whitespace-nowrap cursor-pointer hover:bg-background-100 transition-colors">
                <i className="ri-computer-line mr-2"></i>网页版
              </button>
            </div>
          </div>
          <div className="flex-shrink-0 w-full max-w-[280px]">
            <div className="relative aspect-[9/16] rounded-2xl overflow-hidden border-4 border-foreground-900">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20abstract%20cinematic%20streaming%20interface%20with%20warm%20dark%20theme%2C%20elegant%20film%20poster%20thumbnails%20grid%2C%20golden%20accent%20colors%2C%20modern%20minimal%20UI%20design%2C%20soft%20screen%20glow%2C%20premium%20app%20aesthetic%2C%20clean%20composition&width=450&height=800&seq=97cinema-app-mockup&orientation=portrait"
                alt="97影院移动端追剧界面"
                className="w-full h-full object-cover"
                onError={(e) => { (e.target as HTMLImageElement).setAttribute('data-error', 'true'); }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}